import React from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";

import { NavigationPath, history } from "./utils";
import PageNotFound from "./components/PageNotFound";
import Login from "./components/Authentication/Login";
import ResetPassword from "./components/Authentication/ResetPassword";
import Users from "./components/Users";
import AddUser from "./components/Users/Adduser";
import EditUser from "./components/Users/EditUser";
import Insurance from "./components/Insurance";
import AddInsurance from "./components/Insurance/AddInsurance";
import EditInsurance from "./components/Insurance/EditInsurance";
import PrivateSidebarMenuRoute from "./routing/privateSidebarMenuRoute";
import PrivateNoSidebarMenuRoute from "./routing/privateNoSidebarMenuRoute";
import InsuranceOfferRequests from "./components/InsuranceHome/OfferRequests";
import Orders from "./components/InsuranceHome/Orders";
import OfferResponses from "./components/OfferResponses";
import AddRequest from "./components/OfferRequests/AddRequest";
import EditRequest from "./components/OfferRequests/EditRequest";
import RequestDetails from "./components/InsuranceHome/RequestDetails";
import ResponseSingle from "./components/OfferResponses/ResponseSingle";
import InsuranceResponseInfo from "./components/OfferResponses/ResponseSingle/InsuranceResponseInfo";
import OfferRequests from "./components/OfferRequests";

const AppContainer = () => {
  history.navigate = useNavigate();
  history.location = useLocation();

  return (
    <Routes>
      <Route path={NavigationPath.LOGIN_ROUTE} element={<Login />} />
      <Route
        path={NavigationPath.RESET_PASSWORD_ROUTE}
        element={<ResetPassword />}
      />

      <Route path="/" element={<PrivateSidebarMenuRoute />}>
        <Route
          path={NavigationPath.OFFER_REQUESTS_ROUTE}
          element={<OfferRequests />}
        />
        <Route
          path={NavigationPath.OFFER_RESPONSES_ROUTE}
          element={<OfferResponses />}
        />
        <Route
          path={NavigationPath.SINGLE_OFFER_RESPONSES_ROUTE}
          element={<ResponseSingle />}
        />
        <Route
          path={NavigationPath.SINGLE_RESPONSE_ROUTE}
          element={<InsuranceResponseInfo />}
        />
        <Route
          path={NavigationPath.ADD_OFFER_REQUEST_ROUTE}
          element={<AddRequest />}
        />
        <Route
          path={NavigationPath.EDIT_OFFER_REQUEST_ROUTE}
          element={<EditRequest />}
        />

        <Route path={NavigationPath.USERS_ROUTE} element={<Users />} />
        <Route path={NavigationPath.ADD_USER_ROUTE} element={<AddUser />} />
        <Route path={NavigationPath.EDIT_USER_ROUTE} element={<EditUser />} />

        <Route path={NavigationPath.INSURANCE_ROUTE} element={<Insurance />} />
        <Route
          path={NavigationPath.ADD_INSURANCE_ROUTE}
          element={<AddInsurance />}
        />
        <Route
          path={NavigationPath.EDIT_INSURANCE_ROUTE}
          element={<EditInsurance />}
        />
      </Route>

      <Route element={<PrivateNoSidebarMenuRoute />}>
        <Route
          path={NavigationPath.INSURANCE_OFFER_REQUESTS_ROUTE}
          element={<InsuranceOfferRequests />}
        />
        <Route path={NavigationPath.ORDERS_ROUTE} element={<Orders />} />
        <Route
          path={NavigationPath.INSURANCE_OFFER_RESPONSE_ROUTE}
          element={<RequestDetails />}
        />
      </Route>

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AppContainer;
